export default __webpack_public_path__ + "static/media/temp_img1.0471b3cd.png";